import { useMemo } from 'react';

import { makeSecuredMediaURLRelative } from '@lumapps/medias/utils';

import { Article } from '../api/types';
import { articleView } from '../routes';
import { ArticlePreview } from '../types';

export const useArticlePreview = (article: Article | ArticlePreview, isLegacy?: boolean) => {
    const articleRoute = useMemo(() => articleView(article.id), [article.id]);

    const imageInfos = () => {
        if (isLegacy) {
            const { url, focalPoint } = (article as Article).structuredContent.richText?.value?.featuredImage || {};
            if (!url) {
                return undefined;
            }

            return {
                href: articleRoute,
                url: makeSecuredMediaURLRelative(url) as string,
                focusPoint: focalPoint,
            };
        }

        const { image, focalPoint } = article as ArticlePreview;
        if (!image) {
            return undefined;
        }

        return {
            href: articleRoute,
            url: image,
            focusPoint: focalPoint,
        };
    };

    const title = !isLegacy ? (article as ArticlePreview).title : (article as Article).structuredContent.title?.value;

    const intro = !isLegacy
        ? (article as ArticlePreview).description
        : (article as Article).structuredContent.intro?.value;

    const { author } = article;

    return {
        id: article.id,
        articleRoute,
        image: imageInfos(),
        title,
        intro,
        author,
    };
};
